import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, switchMap } from 'rxjs';

import { ErrorHandlerService } from '../../services/error-handler/error-handler.base-service';
import { FeedbackService } from '../../services/general/feedback.base-service';
import { ServiceFacade } from '../../services/support/service.base-facade';
import * as fromActions from './service.actions';
import { IResidentS3File } from '../../models';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ServiceEffects {
  public loadFaqs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.DownloadDocument),
      switchMap(({ document }) =>
        this.serviceFacade.downloadDocument(document).pipe(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          map((file: any) =>
            fromActions.DownloadDocumentSuccess({
              file,
            })
          ),
          catchError((error: Error) => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on service.effects.ts:loadFaqs$:',
              error
            );
            return [fromActions.DownloadDocumentFailed({ error })];
          })
        )
      )
    )
  );

  public uploadFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.UploadFiles),
      switchMap(({ filePaths }) =>
        from(this.serviceFacade.uploadFiles(filePaths)).pipe(
          map((files: IResidentS3File[]) => fromActions.UploadFilesSuccess({ files })),
          catchError((error: Error) => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on service.effects.ts:uploadFile$:',
              error
            );
            this.feedbackService.error({
              message: this.translate.instant('image_upload.error_l'),
            });
            return [fromActions.UploadFilesFailed({ error })];
          })
        )
      )
    )
  );

  public uploadFileWeb$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.UploadFilesWeb),
      switchMap(({ filePaths }) =>
        this.serviceFacade.uploadFilesWeb(filePaths).pipe(
          map((files: IResidentS3File[]) => fromActions.UploadFilesSuccess({ files })),
          catchError((error: Error) => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on service.effects.ts:uploadFileWeb$:',
              error
            );
            this.feedbackService.error({
              message: this.translate.instant('image_upload.error_l'),
            });
            return [fromActions.UploadFilesFailed({ error })];
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private serviceFacade: ServiceFacade,
    private feedbackService: FeedbackService,
    private translate: TranslateService,
    private errorHandlerService: ErrorHandlerService
  ) {}
}
